export const myPlaceGermanLocalization = {
  screens: {
    myPlace: {
      channels: {
        funkzentrale: 'Funkzentrale',
        gruppen: 'Gruppen & Chats',
        infos: 'Infos'
      },
      tabs: {
        alle: 'Alle',
        news: 'News',
        markt: 'Markt',
        events: 'Events',
        gruppen: 'Gruppen',
        chats: 'Persönliche Chats',
        sagsUns: "Sag's uns",
        territorialAuthority: 'Kommune',
        vereine: 'Vereine',
        ehrenamt: 'Ehrenamt',
        schulen: 'Kitas+Schulen',
        kirche: 'Religion'
      },
      newsFilter: {
        label: 'Bereich',
        alle: 'Alle',
        rathaus: 'Aus dem Rathaus',
        gemeinde: 'Aus der Gemeinde'
      },
      alle: {
        all: 'Alle ansehen',
        neu_one: '{{count}} neu',
        neu_other: '{{count}} neue'
      },
      territorialAuthority: {
        stats: {
          einwohnende: 'Einwohnende',
          flaeche: 'Fläche',
          webseite: 'Webseite'
        },
        empty: 'Keine Kommune für deinen Heimatort gefunden.'
      },
      organizations: {
        members_one: '{{count}} Mitglied',
        members_other: '{{count}} Mitglieder',
        empty: {
          vereine: 'Keine Vereine an deinem Heimatort gefunden.',
          ehrenamt:
            'Keine Ehrenamtsorganisationen an deinem Heimatort gefunden.',
          schulen: 'Keine Kitas oder Schulen an deinem Heimatort gefunden.',
          kirche:
            'Keine kirchlichen Organisationen an deinem Heimatort gefunden.'
        }
      },
      state: {
        error: {
          title: 'Inhalte konnten nicht geladen werden',
          subtitle:
            'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
          retry: 'Erneut versuchen'
        }
      }
    }
  }
};

type MyPlaceLocalization = typeof myPlaceGermanLocalization;

export const myPlaceEnglishLocalization: MyPlaceLocalization = {
  screens: {
    myPlace: {
      channels: {
        funkzentrale: 'Local Hub',
        gruppen: 'Groups & chats',
        infos: 'Community'
      },
      tabs: {
        alle: 'All',
        news: 'News',
        markt: 'Market',
        events: 'Events',
        gruppen: 'Groups',
        chats: 'Personal chats',
        sagsUns: "Sag's uns",
        territorialAuthority: 'Municipality',
        vereine: 'Clubs',
        ehrenamt: 'Volunteering',
        schulen: 'Schools',
        kirche: 'Religion'
      },
      newsFilter: {
        label: 'Area',
        alle: 'All',
        rathaus: 'From the town hall',
        gemeinde: 'From the municipality'
      },
      alle: {
        all: 'View all',
        neu_one: '{{count}} new',
        neu_other: '{{count}} new'
      },
      territorialAuthority: {
        stats: {
          einwohnende: 'Residents',
          flaeche: 'Area',
          webseite: 'Website'
        },
        empty: 'No municipality found for your home area.'
      },
      organizations: {
        members_one: '{{count}} member',
        members_other: '{{count}} members',
        empty: {
          vereine: 'No clubs found in your home area.',
          ehrenamt: 'No volunteering organizations found in your home area.',
          schulen: 'No daycare centers or schools found in your home area.',
          kirche: 'No religious organizations found in your home area.'
        }
      },
      state: {
        error: {
          title: 'Content could not be loaded',
          subtitle: 'Please try again later.',
          retry: 'Try again'
        }
      }
    }
  }
};
